// Burger menu
(function () {
    const headerMenu = document.querySelector(`.header-menu`);
    const body = document.querySelector(`body`);

    if (headerMenu) {
        const buttonOpenMenu = headerMenu.querySelector(`.js-open-menu-button`);
        const buttonCloseMenu = headerMenu.querySelector(`.js-close-menu-button`);
        const overlay = headerMenu.querySelector(`.header-menu__overlay`);

        buttonOpenMenu?.addEventListener(`click`, (evt) => {
            evt.preventDefault();

            body.classList.add(`body--menu-opened`);
        });

        buttonCloseMenu?.addEventListener(`click`, (evt) => {
            evt.preventDefault();

            body.classList.remove(`body--menu-opened`);
        });

        overlay?.addEventListener(`click`, () => {
            body.classList.remove(`body--menu-opened`);
        });
    }
})();